export default function TeamMember(props) {
  return (
    <div className="team-member">
      <p>{props.title}</p>
      <p>{props.name}</p>
      <a class="team-member-email" href={props.mailto}>{props.email}</a>
    </div>
  );
}